import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import CopyrightFooter from './components/copyright-footer';

const Changelog = () => {
  const changelogPath = require('./CHANGELOG.md');
  const [changelog, setChangelog] = useState('');

  useEffect(() => {
    fetch(changelogPath)
      .then((res) => res.text())
      .then((text) => setChangelog(text));
  }, [changelogPath]);

  return (
    <div className='min-h-full'>
      <div className='flex flex-col h-full pt-16 pl-16'>
        <h1 className='text-xl text-sky-900 mb-10'>Changelog</h1>
        <ReactMarkdown children={changelog} remarkPlugins={[remarkGfm]} />
      </div>
      <CopyrightFooter />
    </div>
  );
};

export default Changelog;
